import React, { useState, useEffect, useRef } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import Button from '../Button';
import useAPI from '../../hooks/useAPI';
import useErrors from '../../hooks/useErrors';
import RoundedButton from '../RoundedButton';

export default function PlaidButton ({ children, solid = true, accountId = null }) {
    const api = useAPI();
    const errors = useErrors();

    const [busy, setBusy] = useState(false);
    const [data, setData] = useState(null);

    const connectBank = () => {
        //  Request token
        setBusy(true);

        const body = accountId ? {account_id: accountId} : null;

        api.json('POST', '/payment-methods/plaid/create-link-token', body)
            .then(r => r.json())
            .then((r) => {
                if (r.errors) {
                    errors(r.errors);
                }
                setData(r.data);
            })
            .catch((e) => {
                alert(e);
                setBusy(false);
            });
    };

    const onSuccess = (public_token, metadata) => {
        setBusy(true);

        api.json('POST', '/payment-methods/plaid/capture-token', {
            plaid_token: public_token
        })
            .then(r => r.json())
            .then((r) => {
                if (r.errors) {
                    errors(r.errors);
                    return;
                }

                window.location = '/account/payment-settings';
            })
            .catch((e) => alert(e))
            .then(() => setBusy(false));
    };

    let button = null;
    if(solid === true || solid === 'true'){
        button = <RoundedButton 
            onClick={connectBank} 
            disabled={busy} 
            solid={solid}
        >
            {children|| 'Link Bank Account'}
        </RoundedButton>
    }else{
        button = <Button 
            onClick={connectBank} 
            disabled={busy} 
            solid={solid}
        >
            {children|| 'Link Bank Account'}
        </Button>
    }

    return (
        <>
            {button}
            {
                data ? 
                    <Plaid 
                        token={data.link_token} 
                        onSuccess={onSuccess}
                        onExit={()=>setBusy(false)}
                    /> 
                : null
            }
        </>
    );
};

const Plaid = ({ token, onSuccess, onExit }) => {
    const initialOpen = useRef(false);
    let isOauth = false;
    const config = {
        token,
        onSuccess,
        onExit
    };

    if (window.location.href.includes("?oauth_state_id=")) {
        config.receivedRedirectUri = window.location.href;
        isOauth = true;
    }

    const { open, ready } = usePlaidLink(config);

    useEffect(() => {
        if (isOauth && ready) {
            open();
        }

        if (!initialOpen.current) {
            initialOpen.current = true;
            open();
        }
    }, [ready, open, isOauth]);

    return null;
};